<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [resizable]="false"
  [draggable]="true"
  header="Détails de l'événement"
  [style]="{ width: '550px' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
>
  <div class="event-details p-3">
    <div *ngIf="eventDetails" class="flex flex-col gap-3">
      <h2 class="text-xl font-bold mb-2">{{ eventDetails.title }}</h2>

      <div class="flex items-center gap-2">
        <i class="pi pi-calendar mr-2"></i>
        <span>{{ eventDetails.dateRange }}</span>
      </div>

      <div *ngIf="eventDetails.status" class="flex items-center gap-2">
        <i class="pi pi-info-circle mr-2"></i>
        <span
          class="status-badge"
          [style.background-color]="eventDetails.statusColor"
        >
          {{ eventDetails.status }}
        </span>
      </div>

      <div *ngIf="eventDetails.address" class="flex items-center gap-2">
        <i class="pi pi-map-marker mr-2"></i>
        <span>{{ eventDetails.address }}</span>
      </div>

      <div *ngIf="eventDetails.technicians" class="flex items-center gap-2">
        <i class="pi pi-users mr-2"></i>
        <span>{{ eventDetails.technicians }}</span>
      </div>

      <!-- Affichage des liens d'itinéraire pour chaque technicien -->
      <div
        *ngIf="eventDetails.technicianDetails?.length"
        class="flex flex-col gap-2 mt-2"
      >
        <h3 class="text-md font-semibold">Itinéraires:</h3>
        <div
          *ngFor="let tech of eventDetails.technicianDetails"
          class="flex items-center"
        >
          <span class="tech-initials mr-2">{{ tech.initials }}</span>
          <a
            *ngIf="tech.routeUrl"
            [href]="tech.routeUrl"
            target="_blank"
            class="route-link"
          >
            <i class="pi pi-map mr-1"></i>Itinéraire {{ tech.name }}
          </a>
          <span *ngIf="!tech.routeUrl" class="text-gray-500"
            >Pas d'itinéraire disponible</span
          >
        </div>
      </div>

      <div *ngIf="eventDetails.mlRef" class="flex items-center gap-2">
        <i class="pi pi-tag mr-2"></i>
        <span class="ml-ref">{{ eventDetails.mlRef }}</span>
      </div>

      <div class="mt-3">
        <h3 class="text-lg font-semibold mb-2">Description</h3>
        <p class="whitespace-pre-line">
          {{ eventDetails.description }}
        </p>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <button
        pButton
        label="Fermer"
        icon="pi pi-times"
        class="p-button-text"
        (click)="close()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
